import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I am <span className="purple">Janina Ayoub</span>{" "}
            from <span className="purple">Rabat, Morocco</span>.
            <br />
            I currently work as a <span className="purple">Software Engineer</span>{" "}
            at <span className="purple">Capgemini</span>, after frontend
            engineering work with <span className="purple">IBM</span>.
            <br />
            I studied <span className="purple">Computer Science</span> at{" "}
            <span className="purple">INSEA</span> and hold certifications from{" "}
            <span className="purple">AWS</span> and{" "}
            <span className="purple">Meta</span>.
            <br />
            <br />
            I build production-ready web applications with a focus on:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Responsive React and Next.js interfaces
            </li>
            <li className="about-activity">
              <ImPointRight /> Node.js APIs, authentication, and data models
            </li>
            <li className="about-activity">
              <ImPointRight /> Performance, testing, deployment, and clean UX
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build useful software, then make it fast, clear, and reliable."{" "}
          </p>
          <footer className="blockquote-footer">Janina Ayoub</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
